import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
export class NgPaginateService {
/**
 * @param {?} http
 */
constructor(private http: HttpClient) {}
/**
 * This is used to list all by paginator
 * @param {?} url
 * @return {?}
 */
listByPaginator(url): Observable<any> {
    return this.http.get(url);
  }

static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: HttpClient, },
];
}

function NgPaginateService_tsickle_Closure_declarations() {
/** @type {?} */
NgPaginateService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPaginateService.ctorParameters;
/** @type {?} */
NgPaginateService.prototype.http;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
